/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_appsync_graphqlEndpoint": "https://76tshlu6cjb4hjkat6i3cjveuu.appsync-api.us-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-3p4t2ij5fvbodfkbbpiq4yva3u",
    "aws_cognito_identity_pool_id": "us-west-1:893f9b7f-0fc8-4f18-aeb6-20e175af113b",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_LU7xMvL74",
    "aws_user_pools_web_client_id": "j6eibf38u82cour861lojk0qo",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "katrian-storage-photo-galleries190522-staging",
    "aws_user_files_s3_bucket_region": "us-west-1"
};


export default awsmobile;
